import React from 'react'
import './Features.scss'
import image from '../../img/sprite.svg'
export const Features = () => {
    return (
        <section className="features">
            <div className="feature">
                <svg className="feature__icon">
                    <use xlinkHref={` ${image}#icon-global`}> </use>
                </svg>
                <h4 className="heading-4 heading-4--dark">World´s best luxury homes</h4>
                <p className="feature__text">Lorem, ipsum dolor sit amet consectetur adipisicing elit. Tenetur distinctio necessitatibus pariatur voluptatibus.</p>
            </div>
            <div className="feature">
                <svg className="feature__icon">
                    <use xlinkHref={` ${image}#icon-trophy`}> </use>
                </svg>
                <h4 className="heading-4 heading-4--dark">Alla hem i exlusiva områden</h4>
                <p className="feature__text">Lorem, ipsum dolor sit amet consectetur adipisicing elit. Tenetur distinctio necessitatibus pariatur voluptatibus.</p>
            </div>

            <div className="feature">
                <svg className="feature__icon">
                    <use xlinkHref={` ${image}#icon-map-pin`}> </use>
                </svg>
                <h4 className="heading-4 heading-4--dark">Bara dom bästa husen</h4>
                <p className="feature__text">Lorem, ipsum dolor sit amet consectetur adipisicing elit. Tenetur distinctio necessitatibus pariatur voluptatibus.</p>
            </div>

            <div className="feature">
                <svg className="feature__icon">
                    <use xlinkHref={` ${image}#icon-key`}> </use>
                </svg>
                <h4 className="heading-4 heading-4--dark">Nytt hem inom en vecka</h4>
                <p className="feature__text">Lorem, ipsum dolor sit amet consectetur adipisicing elit. Tenetur distinctio necessitatibus pariatur voluptatibus.</p>
            </div>

            <div className="feature">
                <svg className="feature__icon">
                    <use xlinkHref={` ${image}#icon-presentation`}> </use>
                </svg>
                <h4 className="heading-4 heading-4--dark">Bästa mäklarna i Stockholm</h4>
                <p className="feature__text">Lorem, ipsum dolor sit amet consectetur adipisicing elit. Tenetur distinctio necessitatibus pariatur voluptatibus.</p>
            </div>

            <div className="feature">
                <svg className="feature__icon">
                    <use xlinkHref={` ${image}#icon-lock`}> </use>
                </svg>
                <h4 className="heading-4 heading-4--dark">Säkra betalning hos oss</h4>
                <p className="feature__text">Lorem, ipsum dolor sit amet consectetur adipisicing elit. Tenetur distinctio necessitatibus pariatur voluptatibus.</p>
            </div>


        </section>
    )
}
